import {Injectable, Injector} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {DocumentType} from '../model/Entities/DocumentType';
import {DocumentCompany} from '../model/Entities/DocumentCompany';
import {Pohoda} from '../model/Entities/Pohoda';
import {LocalStorageService} from './local-storage.service';
import {ProgressService} from './progress.service';
import {SnackService} from './snack.service';

@Injectable()
export class PohodaService extends ApiService<Pohoda> {

    protected apiUrl = 'api/pohoda';  // URL to web api

    protected getObjectType(): any {
        return Pohoda;
    }

    constructor(http: HttpClient,
                progressService: ProgressService,
                snackService: SnackService,
                localStorageService: LocalStorageService,
                router: Router,
                private injector: Injector) {
        super(http, progressService, snackService, localStorageService, router);
    }

    exportToXml(params: any = {}): Observable<Blob> {
        let httpParams = new HttpParams();
        for (const paramIndex in params) {
            if (params.hasOwnProperty(paramIndex)) {
                httpParams = httpParams.set(paramIndex, String(params[paramIndex]));
            }
        }

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        if (this.localStorageService.has('user-token')) {
            headers = headers.set('Authorization', 'Bearer ' + this.localStorageService.get('user-token'));
        }

        const httpClient = this.injector.get(HttpClient);
        
        return httpClient.get(`${this.apiRoot}/${this.apiUrl}`, {
            params: httpParams,
            headers: headers,
            responseType: 'blob'
        });
    }
}



// WEBPACK FOOTER //
// /app/src/services/pohoda.service.ts